// extracted by mini-css-extract-plugin
export default {"iconHelp":"styles_iconHelp__Ex4WT","collapse":"styles_collapse__XZXEE"};